
import React from "react";

export class SaudiRiyalLogo extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  static defaultProps = {
    width: 25,
    height: 24,
    color: "#000006",
    strokeWidth: 0.15,
    className: ""
  };

  render() {
    const { width, height, color, strokeWidth, className } = this.props;
    
    return (
      <svg 
        width={width} 
        height={height} 
        viewBox="0 0 12 12" 
        xmlns="http://www.w3.org/2000/svg"
        className={className}
      >
        <g 
          style={{
            fontSize: "8px",
            lineHeight: 0,
            fontFamily: "Andika",
            inkscapeFontSpecification: "Andika",
            opacity: 1,
            vectorEffect: "none",
            fill: color,
            strokeWidth: strokeWidth,
            strokeLinecap: "square",
            strokeLinejoin: "bevel",
            paintOrder: "markers stroke fill"
          }}
        >
          <path 
            d="m6.836 8.468 2.595-.55q-.045.454-.236.876l-2.589.55q.04-.46.23-.876Zm2.359-1.325-2.589.55v-1.65l-.808.173v.916q0 .123-.068.224l-.421.623q-.168.242-.45.298l-2.29.489q.045-.455.236-.876l2.184-.466v-1.04l-2.038.433q.045-.455.235-.87l1.803-.388V2.353q.342-.416.809-.68v3.718l.808-.174v-2.46q.343-.415.803-.68v2.971l2.022-.432q-.045.455-.236.876l-1.786.382v.82l2.022-.427q-.045.46-.236.876Z" 
            style={{
              fontSize: "11.5px",
              fontFamily: "'Gentium Unicode'",
              inkscapeFontSpecification: "'Gentium Unicode'"
            }} 
            aria-label="⃁" 
          />
        </g>
      </svg>
    );
  }
}

// Alternative class component with single size prop
export class SaudiRiyalSvg extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  static defaultProps = {
    size: 16,
    color: "#000006",
    strokeWidth: 0.15,
    className: "",
    style: {}
  };

  render() {
    const { size, color, strokeWidth, className, style } = this.props;
    
    return (
      <svg 
        width={size} 
        height={size} 
        viewBox="0 0 12 12" 
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        style={style}
      >
        <g 
          style={{
            fontSize: "8px",
            lineHeight: 0,
            fontFamily: "Andika",
            inkscapeFontSpecification: "Andika",
            opacity: 1,
            vectorEffect: "none",
            fill: color,
            strokeWidth: strokeWidth,
            strokeLinecap: "square",
            strokeLinejoin: "bevel",
            paintOrder: "markers stroke fill",
            ...style
          }}
        >
          <path 
            d="m6.836 8.468 2.595-.55q-.045.454-.236.876l-2.589.55q.04-.46.23-.876Zm2.359-1.325-2.589.55v-1.65l-.808.173v.916q0 .123-.068.224l-.421.623q-.168.242-.45.298l-2.29.489q.045-.455.236-.876l2.184-.466v-1.04l-2.038.433q.045-.455.235-.87l1.803-.388V2.353q.342-.416.809-.68v3.718l.808-.174v-2.46q.343-.415.803-.68v2.971l2.022-.432q-.045.455-.236.876l-1.786.382v.82l2.022-.427q-.045.46-.236.876Z" 
            style={{
              fontSize: "11.5px",
              fontFamily: "'Gentium Unicode'",
              inkscapeFontSpecification: "'Gentium Unicode'"
            }} 
            aria-label="⃁" 
          />
        </g>
      </svg>
    );
  }
}
